document.addEventListener('turbolinks:load', function () {
    if ($('.projects .filter-btn, .teams .filter-btn, .organizations .filter-btn, .sales_channels .filter-btn, .permit_applications .filter-btn, .contractors .filter-btn, .onsite_inspections .filter-btn, .hud_trip_reports .filter-btn, .client_updates .filter-btn, .health_inspections .filter-btn, .health_inspection_reports .filter-btn, .dfcm_projects .filter-btn, .permits .filter-btn, .code_enforcements .filter-btn, .knowledge-hub .filter-btn, .ce_master_violations .filter-btn, .ce_violations .filter-btn, .public_violation_reports .filter-btn, .invoices .filter-btn').length === 0) {
        return false
    }

    // off() first: this runs every Turbolinks visit and would otherwise stack another handler on document
    $(document).off('click.filterDropdown').on('click.filterDropdown', function (e) {
        var container = $(".filter-dropdown");
        var filterBtn = $('#triggerFilterDropdown')
        // when filter dropdown menu is displayed
        // dropdown menu should close when clicked on anything except filter button and dropdown menu and its children
        // the handling of closing the dropdown menu when clicked on filter button is handled somewhere else
        // and handling it here was causing issues
        var isClickInsideFlatpickr = !!e.target.closest('.flatpickr-calendar');

        if (!container.hasClass('d-none') && !container.is(e.target) && !filterBtn.is(e.target) && container.has(e.target).length === 0 && !isClickInsideFlatpickr) {
            container.addClass('d-none');
            $('.options').addClass('d-none');
        }
    })
});
